export const NAVIGATION_CONTENT_KEY = 'navigationContent';
export const MAIN_CONTENT_KEY = 'mainContent';
export const HEADER_CONTENT_KEY = 'headerContent';



// WEBPACK FOOTER //
// ./src/components/dashboard/constants.js